import { useApi } from '#shared/providers/Api';

// Direct-Pattern reimplementation of client-dashboard's legacy useBlockAccounts (ID-13193), on the
// host-injected api via useApi(); no CancelToken. Pure mutations — nothing is stored, so there is no
// scoped fetching flag (the consuming component raises the blocking loader; loading-conventions).
// blockAccounts/unblockAccounts are the header (all-sub-accounts) actions; blockAccount/unblockAccount
// target one account.
export default function useBlockAccounts() {
  const api = useApi();

  async function blockAccounts() {
    try {
      const res = await api.blockAccounts();

      if (!res.Success) {
        throw new Error(res.ErrorMessage);
      }

      return res;
    } catch (error) {
      console.error(error);
      throw error;
    }
  }

  async function unblockAccounts() {
    try {
      const res = await api.unblockAccounts();

      if (!res.Success) {
        throw new Error(res.ErrorMessage);
      }

      return res;
    } catch (error) {
      console.error(error);
      throw error;
    }
  }

  async function blockAccount(accountID: string) {
    try {
      const res = await api.blockAccounts({ VopayAccountID: accountID });

      if (!res.Success) {
        throw new Error(res.ErrorMessage);
      }

      return res;
    } catch (error) {
      console.error(error);
      throw error;
    }
  }

  async function unblockAccount(accountID: string) {
    try {
      const res = await api.unblockAccounts({ VopayAccountID: accountID });

      if (!res.Success) {
        throw new Error(res.ErrorMessage);
      }

      return res;
    } catch (error) {
      console.error(error);
      throw error;
    }
  }

  return { blockAccounts, unblockAccounts, blockAccount, unblockAccount };
}
